import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-retail-vs-municipalities-vs-other-filters',
  templateUrl: './retail-vs-municipalities-vs-other-filters.component.html',
  styleUrls: ['./retail-vs-municipalities-vs-other-filters.component.scss']
})
export class RetailVsMunicipalitiesVsOtherFiltersComponent implements OnInit {

  @Input()
  years!: number[];

  responseType = [
    {value: 'retail', description: 'Retail'},
    {value: 'municipal', description: 'Municipalities'},
    {value: 'other', description: 'Other'},
  ];

  searchForm = this.formBuilder.group({
    year: [''],
    responseType: [''],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get responseTypeControl(): FormControl {
    return this.searchForm.get('responseType') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({
      year: this.yearControl.value,
      responseType: this.responseTypeControl.value
    } as IntelligenceSearchInterface);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.responseTypeControl.setValue(null);
    this.search.emit({year: this.yearControl.value} as IntelligenceSearchInterface);
  }

}
